export const REQUIRED_INVOICE = "REQUIRED_INVOICE" as const;
export const REQUIRED_INVOICE_LINE_ITEM = "REQUIRED_INVOICE_LINE_ITEM" as const;
export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE" as const;
export const UPDATE_COMPANY_LOGO = "UPDATE_COMPANY_LOGO" as const;
export const ADD_USER_PROFILE = "ADD_USER_PROFILE" as const;
export const UPDATE_FORMDATA = "UPDATE_FORMDATA" as const;
export const TURN_FLAG = "TURN_FLAG" as const;
export const NOTIFY_COUNT = "NOTIFY_COUNT" as const;
export const ISUPDATED = "ISUPDATED" as const;
